{
  "email": "メール",
  "emailAddress": "メールアドレス",
  "emailAddressPlaceholder": "メールアドレスを入力してください",
  "continue": "続ける",
  "send": "送信",
  "resend": "再送信",
  "sendCodeErrorTip": "コード送信に失敗しました: {error}",
  "sendEmailTips": "確認コードをメールに送信しました",
  "verificationCode": "確認コード",
  "codePlaceholder": "コードを入力してください",
  "wallet": "ウォレット",
  "otherLoginMethods": "その他のログイン方法",
  "login": "ログイン",
  "user": "ユーザー",
  "loginTitle": "ログイン / 登録",
  "loginTips": "以下の方法でログインできます",
  "passwordMinError": "パスワードは最低 {length} 文字必要です",
  "passwordMatchError": "入力されたパスワードが一致しません",
  "passwordTitle": "パスワードを設定",
  "passwordTips": "ウォレット復元用のパスワードを設定してください",
  "password": "パスワード",
  "passwordPlaceholder": "パスワードを入力してください",
  "rePassword": "パスワード確認",
  "rePasswordPlaceholder": "再度パスワードを入力してください",
  "recoverTitle": "ウォレットを復元",
  "recoverTips": "パスワードを入力してウォレットを復元してください",
  "bindWith": "{name}ウォレットと連携",
  "loginWith": "{name}ウォレットでログイン",
  "editUsernameTitle": "ユーザー名を編集",
  "setUsernameTitle": "ユーザー名を設定",
  "username": "ユーザー名",
  "usernamePlaceholder": "ユーザー名を入力してください",
  "usernameValidError": "名前は文字、数字、記号で構成できます",
  "usernameLengthError": "2文字以上で入力してください",
  "confirm": "確認",
  "nextTime": "次回",
  "setUsername": "ユーザー名を設定",
  "disconnect": "切断",
  "CEXBindTitle": "{type} API をバインド",
  "CEXBindAttention": "注意：",
  "CEXBindTips1": "1. 読み取り専用の権限で API をバインドしてください。",
  "CEXBindTips2": "2. API が古い可能性があります。長期間使用可能な API を使用することをお勧めします。",
  "CEXBindTips3": "3. 同じ取引所に同時にバインドできる API は1つだけです。",
  "CEXBindApiKey": "API キー",
  "CEXBindApiSecretKey": "API シークレットキー",
  "CEXBindApiPassphrase": "API パスフレーズ",
  "cancel": "キャンセル",
  "walletLoading": "ウォレットサービスを読み込んでいます",
  "tokenDetails": "トークンの詳細",
  "tokenAmountMin": "金額は0より大きくなければなりません。",
  "tokenAmountMax": "残高が不足しています。",
  "tokenAddressError": "無効なアドレスです。",
  "amount": "金額",
  "amountPlaceholder": "金額を入力してください。",
  "balance": "残高",
  "receiveTitle": "受取ウォレットアドレス",
  "receivePlaceholder": "受取ウォレットアドレスを入力してください。",
  "next": "次へ",
  "copied": "コピーしました",
  "receiveQrcode": "QRコードをスキャンして受け取る",
  "copyAddress": "アドレスをコピー",
  "tokenSmartContract": "トークンのスマートコントラクト",
  "tokenSmartContractPlaceholder": "トークンのスマートコントラクトを入力してください。",
  "tokenSymbol": "トークンシンボル",
  "tokenSymbolPlaceholder": "トークンシンボルを入力してください。",
  "tokenDecimals": "小数点",
  "tokenDecimalsPlaceholder": "小数点を入力してください。",
  "import": "インポート",
  "receive": "受け取る",
  "customizedToken": "カスタマイズトークン",
  "noMoreRecords": "これ以上の記録はありません！",
  "noRecords": "記録がありません！",
  "close": "閉じる",
  "back": "戻る",
  "importSuccess": "トークンのインポートに成功しました",
  "importFail": "トークンのインポートに失敗しました",
  "changeNetwork": "ネットワークを変更",
  "approveSuccess": "承認に成功しました",
  "Approve": "承認",
  "noFriends": "まだ友達がいません",
  "noRequests": "まだリクエストがありません",
  "noMore": "これ以上ありません",
  "Remove": "削除",
  "removeSuccess": "削除に成功しました"

}
